import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { ApiResult } from 'src/Libs/api'
import { handleFetchError } from 'src/Libs/api/utils'
import { signalDownload } from 'src/Libs/documents/functions'

import {
  comparePortalVersions,
  getWebviewPortalVersion,
  handleReactNativeFileDownloadFromUrl,
  VersionComparison,
} from '@e3dc-react/shell/Libs/webview'
import { InstallationStatementLanguage, InstallationStatementLanguageType } from '../types'
import { PORTAL_VERSION_FOR_OLD_REACT_NATIVE_DOWNLOAD } from 'src/Libs/nda'

export interface InstallationStatementLinkResponse {
  installationStatementsFormDownloadLink: string
}

/**
 * Fetch link to download Installation Statement file in given language
 */
export const fetchInstallationStatementFileLink = async (
  authFetch: AuthFetchWithResponse,
  language: InstallationStatementLanguageType = InstallationStatementLanguage.GERMAN
): Promise<ApiResult<InstallationStatementLinkResponse>> => {
  try {
    const response = await authFetch<InstallationStatementLinkResponse>({
      path: `installations/statements/forms/${language}`,
      method: 'GET',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
    })
    if (response.status === StatusCodes.OK) {
      return new ApiResult<InstallationStatementLinkResponse>(response.data, false)
    }
    return new ApiResult<InstallationStatementLinkResponse>(null, true)
  } catch (error) {
    return handleFetchError<InstallationStatementLinkResponse>(error)
  }
}

/**
 * Trigger actual download for the given link
 */
export const downloadInstallationStatementFile = (fileUrl: string, filename: string, isWebview: boolean): void => {
  const webViewPortalVersion = getWebviewPortalVersion()

  if (
    isWebview &&
    webViewPortalVersion &&
    comparePortalVersions(webViewPortalVersion, PORTAL_VERSION_FOR_OLD_REACT_NATIVE_DOWNLOAD) === VersionComparison.Greater
  ) {
    handleReactNativeFileDownloadFromUrl(fileUrl, filename, 'pdf', 'application/pdf')
  } else {
    signalDownload(fileUrl, `${filename}.pdf`, true)
  }
}
